<template>
  <div class="c-app-board fs">
    <el-row v-if="header && header?.hidden !== true" :gutter="gutter">
      <CAppBoardSection :gutter="gutter" v-bind="header" />
    </el-row>
    <div class="c-app-board-content">
      <div class="c-app-board-top" v-if="top">
        <CAppBoardSection :gutter="gutter" span="24" v-bind="top" />
      </div>
    </div>
    <el-row :gutter="gutter" class="c-app-board-content">
      <div class="c-app-board-left">
        <CAppBoardSection v-if="left" :gutter="gutter" v-bind="left" />
        <CAppBoardSection :gutter="gutter" v-bind="main" />
      </div>
      <div class="c-app-board-right" v-if="right">
        <CAppBoardSection :gutter="gutter" v-bind="right" />
      </div>
    </el-row>
    <el-row v-if="footer && footer?.hidden !== true" :gutter="gutter">
      <CAppBoardSection :gutter="gutter" v-bind="footer" />
    </el-row>
  </div>
</template>

<script setup lang="ts">
import { _, ref, computed, reactive, provide, onMounted, useHostAppInstance } from '@zto/zpage'
import type { ApiRequestAction } from '@zto/zpage'

import type { AppBoardSection } from './types'

import { APP_BOARD_STATE_KEY } from './consts'
import { getPayloadData } from './util'

const props = withDefaults(
  defineProps<{
    gutter?: number

    api?: ApiRequestAction | string // api 触发
    apiParams?: Record<string, any> | Function // API参数
    payload?: Function

    onLoad?: Record<string, any> | Function

    header?: AppBoardSection
    top?: AppBoardSection,
    left?: AppBoardSection
    main?: AppBoardSection
    right?: AppBoardSection
    footer?: AppBoardSection
  }>(),
  {
    gutter: 10
  }
)

const app = useHostAppInstance()

const CAppBoardSection = app.resolveComponent('CAppBoardSection')

const boardConfig = app.useAppConfig('board', {})

const boardState = reactive({
  model: {},
  config: boardConfig
})

provide(APP_BOARD_STATE_KEY, boardState)

const innerContext = app.useContext(boardState)

onMounted(async () => {
  boardState.model = await fetchPayload()

  if (props.onLoad) {
    await props.onLoad(innerContext)
  }
})

async function fetchPayload() {
  let payload = {}

  if (props.payload) {
    payload = await getPayloadData(props.payload, innerContext)
    return payload
  }

  const api = props.api || boardConfig.api
  if (api) {
    const apiParams = props.apiParams || boardConfig.apiParams

    const params = await getPayloadData(apiParams, innerContext)

    payload = await app.request({ action: api, params })
  }

  return payload
}
</script>

<style lang="scss" scoped>
.c-app-board {
  overflow-x: hidden;
  padding-bottom: 20px;
  box-sizing: border-box;
}

.c-app-board-content {
  display: flex;
  width: 100%;
}

.c-app-board-top {
  width: 100%;
}

.c-app-board-left {
  flex: 1;
  min-width: 0;
}

.c-app-board-right {
  width: 380px;
  margin-left: var(--el-gutter);
}
</style>
